// *********************************************************************************************************************
// Custom JavaScript
// *********************************************************************************************************************


// =====================================================================================================================
// Breakpoint Manager
// =====================================================================================================================
import BreakpointManager from './breakpoint-manager'

// Custom Breakpoints object
const breakpoints = {
    xs:     0,
    sm:   576,
    md:   768,
    lg:  1100,
    xl:  1350,
    xxl: 1600,
}

// Instantiate the Breakpoint Manager
const breakpointManager = new BreakpointManager(breakpoints, true);



// =====================================================================================================================
// Bootstrap Imports
// =====================================================================================================================
import Dropdown from "bootstrap/js/dist/dropdown";
import Tab from "bootstrap/js/dist/tab";
import Collapse from "bootstrap/js/dist/collapse";




// =====================================================================================================================
// Nav Bar
// =====================================================================================================================

// Set up constants
const nav = document.getElementById("main-nav");
const adminBar = document.getElementById('wpadminbar'); // WordPress Admin Bar


// Change Nav state after scrolling down
// -----------------------------------------------------------------------------------------------------------------
if (nav) {
    function setNavState() {
        const scrollPoint = 30; // pixel value after which state change is triggered
        this.scrollY > scrollPoint ? nav.classList.add('scrolled') : nav.classList.remove('scrolled');
    }
    window.addEventListener('scroll', setNavState);
    window.addEventListener('DOMContentLoaded', setNavState);
}



// Set the nav size for use in CSS
// ---------------------------------------------------------------------------------------------------------------------
function setCssNavbarHeight() {
    if (this.scrollY < 30 ) {
        document.documentElement.style.setProperty('--nav-height', nav.offsetHeight + "px");
    }
}

window.addEventListener('load', setCssNavbarHeight);
document.addEventListener('DOMContentLoaded', setCssNavbarHeight, false);
window.addEventListener('resize', setCssNavbarHeight, false);

// Get the size of the navbar at all times
function setCssNavbarHeightScrolled() {
    document.documentElement.style.setProperty('--nav-height-scrolled', nav.offsetHeight + "px");
}
window.addEventListener('load', setCssNavbarHeightScrolled);
document.addEventListener('DOMContentLoaded', setCssNavbarHeightScrolled, false);
window.addEventListener('resize', setCssNavbarHeightScrolled, false);
window.addEventListener('scroll', function () {
    setTimeout(function (){
        document.documentElement.style.setProperty('--nav-height-scrolled', nav.offsetHeight + "px");
    }, 300);
});


// Check for WordPress admin bar and pushes Nav down if it exists
// ---------------------------------------------------------------------------------------------------------------------
if (adminBar) {
    function setAdminBarHeight() {
        document.documentElement.style.setProperty('--admin-bar-height', adminBar.offsetHeight + "px");
    }

    window.addEventListener('load', setAdminBarHeight);
    document.addEventListener('DOMContentLoaded', setAdminBarHeight, false);
    window.addEventListener('resize', setAdminBarHeight, false);

    // Change Nav state after scrolling past start scrollPoint
    window.addEventListener('scroll', function () {
        if (breakpointManager.matchesBreakpointsDown('xs')) {
            let adminBarHeight = adminBar.offsetHeight;

            if (this.scrollY > adminBarHeight) {
                document.documentElement.style.setProperty('--admin-bar-height', "0px");
            } else if (this.scrollY < adminBarHeight) {
                let adminBarOffset = adminBarHeight  - this.scrollY;
                document.documentElement.style.setProperty('--admin-bar-height', adminBarOffset + "px");
            }
        }
    });

}

// Navbar Toggle - for use with Offcanvas
const navbarOffcanvas = document.getElementById('navbarOffcanvas')
if (navbarOffcanvas) {
    const navToggler = document.getElementById('nav-menu-btn');

    navbarOffcanvas.addEventListener('show.bs.offcanvas', () => {
        navToggler.classList.remove('collapsed');
    })
    navbarOffcanvas.addEventListener('hide.bs.offcanvas', () => {
        navToggler.classList.add('collapsed');
    })
}



// Move all Modal Window elements to the body root
document.addEventListener('DOMContentLoaded', function() {
    const modalElements = document.querySelectorAll('.modal');

    modalElements.forEach(modal => {
        if (modal.parentElement !== document.body) {
            document.body.appendChild(modal);
        }
    });
});



// =====================================================================================================================
// Scroll Bar
// =====================================================================================================================

// Set the Scroll Bar size for use in CSS
function setCSSScrollbarWidth() {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--scrollbar-width', (scrollbarWidth) + "px");
}

// Set scrollbar width on events
window.addEventListener('load', setCSSScrollbarWidth);
document.addEventListener('DOMContentLoaded', setCSSScrollbarWidth, false);
window.addEventListener('resize', setCSSScrollbarWidth, false);



// =====================================================================================================================
// Filters
// =====================================================================================================================

/**
 * Bind Filter Form
 * Sets the JS filter functionality for a given form
 *
 * @param {string} id the HTML ID of the form
 * @param {string} path the path to submit the form to
 */
function bindFilterForm(id, path) {
    const form = document.getElementById(id);
    if (!form) return;
    form.addEventListener('change', () => {
        if (window.location.href.indexOf("/page/") > -1) {
            form.action = window.location.origin + path;
        }

        // Remove blank fields from submission
        Array.from(form.elements).forEach(el => {
            if (el.name && !el.value.trim()) {
                el.removeAttribute('name');
            }
        });

        form.submit();
    });
}

// Unique form filter bindings
const filterForms = [
    ['resource-filters', '/resources/'],
    ['doc-filters', '/sds/'],
    ['label-filters', '/labels/'],
    ['blog-filters', '/blog/'],
    ['product-filters', '/products/'],
];
filterForms.forEach(([id, path]) => bindFilterForm(id, path));




// =====================================================================================================================
// Splide
// =====================================================================================================================

import Splide from '@splidejs/splide';

// Post Slider
// ---------------------------------------------------------------------------------------------------------------------
const postSliders = document.querySelectorAll('.post-slider .splide');
postSliders.forEach( postSlider => {
    const slideCount = postSlider.querySelectorAll('.splide__slide').length;

    const slider = new Splide(postSlider, {
        type: 'slide',
        perPage: 4,
        autoplay: false,
        arrows: slideCount > 4,
        pagination: slideCount > 4,
        drag: slideCount > 4,
        gap: '1.5rem',
        breakpoints: {
            1200: {
                perPage: 3,
                arrows: slideCount > 3,
                pagination: slideCount > 3,
                drag: slideCount > 3,
            },
            1100: {
                perPage: 2,
                arrows: slideCount > 2,
                pagination: slideCount > 2,
                drag: slideCount > 2,
            },
            768: {
                perPage: 1,
                arrows: slideCount > 1,
                pagination: slideCount > 1,
                drag: slideCount > 1,
            },
        }
    });
    slider.mount()
})



// Product Gallery Slider
// ---------------------------------------------------------------------------------------------------------------------
const productGalleryDisplay = document.getElementById("product-gallery-display");
const productGalleryThumbnails = document.getElementById("product-gallery-thumbnails");
if (productGalleryDisplay && productGalleryThumbnails) {
    const galleryDisplaySlider = new Splide(productGalleryDisplay, {
        type: 'fade',
        pagination: false,
        arrows: false,
        cover: false,
        drag: false,
    });

    const thumbnailCount = productGalleryThumbnails.querySelectorAll('.splide__slide').length;
    const galleryThumbnailSlider = new Splide( productGalleryThumbnails, {
        mediaQuery: 'min',
        isNavigation: true,
        pagination: false,
        drag: true,
        arrows: false,

        gap: 10,
        fixedHeight: 80,
        fixedWidth: 80 * 1.2,

        breakpoints: {
            768: {
                direction: 'ttb',
                height: '100%',
                gap: 20,
            },
            1100: {
                direction: 'ltr',
                gap: 10,
                height: undefined

            },
            1600: {
                direction: 'ttb',
                height: '100%',
                gap: 20,
            },
        },
    });

    galleryDisplaySlider.sync( galleryThumbnailSlider );
    galleryDisplaySlider.mount();
    galleryThumbnailSlider.mount();
}



// Image Link Slider
// ---------------------------------------------------------------------------------------------------------------------
const imageLinkSliders = document.querySelectorAll('.image-link-slider .splide');
imageLinkSliders.forEach( imageLinkSlider => {
    const slideCount = imageLinkSlider.querySelectorAll('.splide__slide').length;

    let slider;
    if (slideCount >= 5) {
        slider = new Splide(imageLinkSlider, {
            type: 'slide',
            perPage: 5,
            autoplay: false,
            arrows: slideCount > 5,
            pagination: slideCount > 5,
            drag: slideCount > 5,
            gap: '1.5rem',
            breakpoints: {
                1350: {
                    perPage: 4,
                    arrows: true,
                    pagination: true,
                    drag: true,
                },
                1100: {
                    perPage: 3,
                },
                768: {
                    perPage: 2,
                },
                575: {
                    perPage: 1,
                },

            }
        });
    }
    else if (slideCount === 4) {
        slider = new Splide(imageLinkSlider, {
            type: 'slide',
            perPage: 4,
            autoplay: false,
            arrows: false,
            pagination: false,
            drag: false,
            gap: '1.5rem',
            breakpoints: {
                1100: {
                    perPage: 3,
                    arrows: slideCount > 3,
                    pagination: slideCount > 3,
                    drag: slideCount > 3,
                },
                768: {
                    perPage: 2,
                    arrows: slideCount > 2,
                    pagination: slideCount > 2,
                    drag: slideCount > 2,
                },
                575: {
                    perPage: 1,
                    arrows: slideCount > 1,
                    pagination: slideCount > 1,
                    drag: slideCount > 1,
                },
            }
        });
    }
    else if (slideCount === 3) {
        slider = new Splide(imageLinkSlider, {
            type: 'slide',
            perPage: 3,
            autoplay: false,
            arrows: false,
            pagination: false,
            drag: false,
            gap: '1.5rem',
            breakpoints: {
                768: {
                    perPage: 2,
                    arrows: slideCount > 2,
                    pagination: slideCount > 2,
                    drag: slideCount > 2,
                },
                575: {
                    perPage: 1,
                    arrows: slideCount > 1,
                    pagination: slideCount > 1,
                    drag: slideCount > 1,
                },
            }
        });
    }
    else {
        slider = new Splide(imageLinkSlider, {
            type: 'slide',
            perPage: 2,
            autoplay: false,
            arrows: false,
            pagination: false,
            drag: false,
            gap: '1.5rem',
            breakpoints: {
                575: {
                    perPage: 1,
                    arrows: slideCount > 1,
                    pagination: slideCount > 1,
                    drag: slideCount > 1,
                },
            }
        });
    }


    slider.mount()
})



// Scroll List Slider
// ---------------------------------------------------------------------------------------------------------------------
const scrollListSliders = document.querySelectorAll('.scroll-list .splide');
scrollListSliders.forEach((list) => {
    const slider = new Splide(list, {
        mediaQuery: 'min',
        arrows: true,
        pagination: true,
        perPage: 1,
        perMove: 1,
        gap: '2rem',
        breakpoints: {
            768: {
                destroy: true,
            }
        }
    });
    slider.mount()
});



// Info Cards Slider
// ---------------------------------------------------------------------------------------------------------------------
const infoCardsSliders = document.querySelectorAll('.info-cards .splide');
infoCardsSliders.forEach((list) => {
    const slides = list.querySelectorAll('.splide__slide');
    let slideCount = slides.length;
    let hasIntroSlide = Array.from(slides).some((slide) => slide.classList.contains('intro-slide'));
    let slideCountWithoutIntro = hasIntroSlide ? slideCount - 1 : slideCount;
    console.log('has intro slide: ', hasIntroSlide);
    const slider = new Splide(list, {
        mediaQuery: 'min',
        arrows: slideCountWithoutIntro > 1,
        pagination: slideCountWithoutIntro > 1,
        perMove: 1,
        perPage: 1,
        drag: slideCountWithoutIntro > 1,
        gap: '1.5rem',
        breakpoints: {
            576: { // sm
                perPage: 2,
                perMove: slideCountWithoutIntro > 2 ? 2 : 1,
                arrows: slideCountWithoutIntro > 2,
                pagination: slideCountWithoutIntro > 2,
                drag: slideCountWithoutIntro > 2,
            },
            768: { // md
                perPage: undefined,
                fixedWidth: 260,
                perMove: slideCount > 3 ? 2 : 1,
                arrows: slideCount > 2,
                pagination: slideCount > 2,
                drag: slideCount > 2,
                focus: slideCount > 2 ? 'center' : undefined,
                trimSpace: 'move',
            },
            1100: { // lg
                perMove: (function () {
                    if (slideCount <= 4) return 1;
                    if (slideCount <= 5) return 2;
                    return 3;
                })(),
                arrows: slideCount > 3,
                pagination: slideCount > 3,
                drag: slideCount > 3,
                focus: slideCount > 3 ? 'center' : undefined,
            },
            1350: { // xl
                perMove: (function () {
                    if (slideCount <= 5) return 1;
                    if (slideCount <= 6) return 2;
                    if (slideCount <= 7) return 3;
                    return 4;
                })(),
                pagination: slideCount > 4,
                arrows: slideCount > 4,
                drag: slideCount > 4,
                focus: slideCount > 4 ? 'center' : undefined,
            },
            1600: { // xxl
                perMove: (function () {
                    if (slideCount <= 6) return 1;
                    if (slideCount <= 7) return 2;
                    if (slideCount <= 8) return 3;
                    if (slideCount <= 9) return 4;
                    return 5;
                })(),
                arrows: slideCount > 5,
                pagination: slideCount > 5,
                drag: slideCount > 5,
                focus: slideCount > 5 ? 'center' : undefined,
            }
        }
    });
    slider.mount()

    // Handle adding and removing of intro slide
    const introSlide = list.querySelector('.intro-slide');
    if (introSlide) {
        function handleIntroSlide() {
            if (window.innerWidth < 768) {
                if (list.contains(introSlide)) {
                    slider.remove(0);
                }
            }
            else {
                if (!list.contains(introSlide)) {
                    slider.add(introSlide, 0);
                }
            }
        }
        handleIntroSlide();
        window.addEventListener('resize', handleIntroSlide);
    }

});



// Product List
// ---------------------------------------------------------------------------------------------------------------------
const productListSliders = document.querySelectorAll('.product-list .splide');
productListSliders.forEach((list) => {
    const slider = new Splide(list, {
        mediaQuery: 'min',
        arrows: true,
        pagination: true,
        perPage: 1,
        perMove: 1,
        gap: '1.5rem',
        breakpoints: {
            768: {
                destroy: true,
            }
        }
    });
    slider.mount()
});



// Slider Group Block
// ---------------------------------------------------------------------------------------------------------------------
const sliderGroups = /** @type {NodeListOf<HTMLElement>} */ (document.querySelectorAll('.slider-group .splide'));
sliderGroups.forEach(function(sliderGroup) {
    // Get data from HTML
    const data = sliderGroup.dataset;
    let sliderType = data.slidertype ?? 'slide';
    let hasArrows = data.arrows === 'true';
    let hasPagination = data.pagination === 'true';
    let hasDrag = data.drag === 'true';
    let hasAutoplay = data.autoplay === 'true';
    let gap = data.gap ?? null;
    let padding = data.padding ?? null;
    let isResponsivePerPage = data.responsiveperpage === 'true';

    // Build out Slider Options
    let sliderOptions = {
        type: sliderType,
        arrows: hasArrows,
        pagination: hasPagination,
        drag: hasDrag,
        autoplay: hasAutoplay,
    }

    // Load optional settings
    if (hasAutoplay) {
        sliderOptions.interval = data.interval ?? 5000;
    }
    if (gap) {
        sliderOptions.gap = gap;
    }
    if (padding) {
        sliderOptions.padding = padding;
    }
    if (isResponsivePerPage) {
        let perPage = JSON.parse(data.perpage);
        sliderOptions.mediaQuery = 'min';
        sliderOptions.perPage = perPage['xs'];
        sliderOptions.breakpoints = {
            576:  { perPage: perPage['sm'] },
            768:  { perPage: perPage['md'] },
            1100: { perPage: perPage['lg'] },
            1350: { perPage: perPage['xl'] },
            1600: { perPage: perPage['xxl'] },
        }
    }
    else {
        sliderOptions.perPage = data.perpage ?? 1;
    }

    // Mount slider
    const slider = new Splide(sliderGroup, sliderOptions)
    slider.mount();
});



// Hero Slider
// ---------------------------------------------------------------------------------------------------------------------
const heroSliders = /** @type {NodeListOf<HTMLElement>} */ document.querySelectorAll('.hero-slider .splide');
heroSliders.forEach(heroSlider => {
    const paginationButtons = heroSlider.querySelectorAll('.hero-pagination-btn');
    const paginationBars = heroSlider.querySelectorAll('.pagination-bar');


    const slides = heroSlider.querySelectorAll('.splide__slide');

    const slider = new Splide(heroSlider, {
        type: 'fade',
        rewind: true,
        autoplay: true,
        interval: 6000,
        speed: 1000,
        pauseOnHover: false,
        pauseOnFocus: false,
        arrows: false,
        pagination: false,
        drag: false,
    });

    // Animate in a slide's eyebrow, heading, and button
    function animateSlideContent(index) {
        const slide = slides[index];
        const eyebrow = slide.querySelector('.slide-eyebrow');
        const heading = slide.querySelector('.slide-heading');
        const button = slide.querySelector('.btn');

        if (eyebrow) {
            gsap.from(eyebrow, {
                opacity: 0,
                y: '-20px',
                duration: 0.8,
                delay: 0,
            });
        }
        if (heading) {
            const headingSplit = SplitText.create(heading, {
                type: 'lines',
                mask: 'lines',
            });
            gsap.from(headingSplit.lines, {
                yPercent: 100,
                opacity: 0,
                duration: 0.8,
                delay: 0.4,
                ease: 'power3.out',
                stagger: 0.08,
                onComplete: () => headingSplit.revert(),
            });
        }
        if (button) {
            gsap.from(button, {
                opacity: 0,
                y: '20px',
                duration: .8,
                delay: 0.8,
            });
        }
    }

    // Set pagination button active state
    let currentIndex = 0;
    slider.on('move', (newIndex) => {
        const paginationTitleMobile = heroSlider.querySelectorAll('.hero-pagination-title-mobile');

        // Remove state from old button
        paginationButtons[currentIndex].classList.remove('is-active');
        paginationButtons[currentIndex].disabled = false;
        paginationBars[currentIndex].style.width = '0%';
        paginationTitleMobile[currentIndex].classList.remove('is-active');

        // Set state on new button
        currentIndex = newIndex;
        paginationButtons[currentIndex].classList.add('is-active');
        paginationButtons[currentIndex].disabled = true;
        paginationTitleMobile[currentIndex].classList.add('is-active');

        animateSlideContent(currentIndex);
    });

    // Set autoplay progress bar
    slider.on('autoplay:playing', (rate) => {
        paginationBars[currentIndex].style.width = (rate * 100) + '%';
    });

    // Set pagination as buttons
    paginationButtons.forEach((item, i) => {
        item.addEventListener('click', () => {
            slider.go(i)
        });
    });

    // Mount the slider
    slider.mount();

    // Animate in the first slide's content on load
    animateSlideContent(currentIndex);
});




// =====================================================================================================================
// GSAP
// =====================================================================================================================
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
gsap.registerPlugin(ScrollTrigger, SplitText);
let matchMedia = gsap.matchMedia();


// Parallax Video Fix
// ---------------------------------------------------------------------------------------------------------------------
const videoParallax = document.querySelectorAll(".video-parallax");
videoParallax.forEach(block => {
    const videoContainer = block.querySelector(".wp-block-video");
    ScrollTrigger.create({
        trigger: block,
        start: "top bottom",
        end: "bottom top",
        onToggle: (self) => { videoContainer.style.display = self.isActive ? "" : "none";}
    });
})



// Hero Parallax Animations Fixed Top Hide
// ---------------------------------------------------------------------------------------------------------------------
const heroParallaxBlocks = document.querySelectorAll(".hero-parallax");
heroParallaxBlocks.forEach((block) => {
    const fixedTop = block.querySelector(".parallax-fixed-top");
    const scrollbug = block.querySelector(".scrollbug-wrapper");

    if (fixedTop) {
        gsap.fromTo(
            fixedTop,
            {
                opacity: 1,
                display: "block",
            },
            {
                opacity: 0,
                ease: "none",
                scrollTrigger: {
                    trigger: block,
                    start: () => `bottom top+=${fixedTop.offsetHeight + 100}`,
                    end: () => `bottom top+=${fixedTop.offsetHeight}`,
                    scrub: true,
                    invalidateOnRefresh: true,
                    onEnter: () => {
                        fixedTop.style.display = "block";
                    },
                    onEnterBack: () => {
                        fixedTop.style.display = "block";
                    },
                    onLeave: () => {
                        fixedTop.style.display = "none";
                    },
                    onLeaveBack: () => {
                        fixedTop.style.display = "block";
                    },
                }
            }
        );
    }

    if (scrollbug) {
        gsap.fromTo(
            scrollbug,
            {
                opacity: 1,
                display: "block",
            },
            {
                opacity: 0,
                ease: "none",
                scrollTrigger: {
                    trigger: block,
                    start: "bottom bottom+=200",
                    end: "bottom bottom",
                    scrub: true,
                    invalidateOnRefresh: true,
                    onEnter: () => {
                        scrollbug.style.display = "block";
                    },
                    onEnterBack: () => {
                        scrollbug.style.display = "block";
                    },
                    onLeave: () => {
                        scrollbug.style.display = "none";
                    },
                    onLeaveBack: () => {
                        scrollbug.style.display = "block";
                    },
                }
            }
        );
    }
});



// Home Hero Buttons
// ---------------------------------------------------------------------------------------------------------------------
const homeHero = document.querySelector("#home-hero");
if (homeHero) {
    const heroButtons = homeHero.querySelector(".home-hero-buttons");

    if (heroButtons) {
        matchMedia.add("(min-width: 1100px)", () => {
            let distance = 0;

            const updateDistance = () => {
                const heroHeight = homeHero.offsetHeight;
                const viewportHeight = window.innerHeight;
                distance = Math.max(0, heroHeight - viewportHeight);
            };

            const refreshScrollTrigger = () => ScrollTrigger.refresh();

            updateDistance();

            gsap.set(heroButtons, {
                y: () => -distance
            });

            gsap.to(heroButtons, {
                y: 0,
                ease: "none",
                scrollTrigger: {
                    trigger: homeHero,
                    start: "top top",
                    end: () => `+=${distance || 1}`,
                    scrub: 1,
                    invalidateOnRefresh: true,
                    onRefresh: () => {
                        updateDistance();
                        gsap.set(heroButtons, { y: -distance });
                    }
                }
            });

            window.addEventListener("resize", refreshScrollTrigger);

            return () => {
                window.removeEventListener("resize", refreshScrollTrigger);
                gsap.set(heroButtons, { clearProps: "transform" });
            };
        });
    }
}



// Split Button Hover functionality
// ---------------------------------------------------------------------------------------------------------------------
const splitButtons = document.querySelectorAll(".split-button");
function setSplitButtonWidths() {
    splitButtons.forEach(button => {
        const buttonText = button.querySelector(".button-text");
        if (buttonText) {
            buttonText.style.minWidth = '';
            buttonText.style.minWidth = buttonText.offsetWidth + "px";
        }
    })
}
window.addEventListener('load', setSplitButtonWidths);
window.addEventListener('resize', setSplitButtonWidths);

splitButtons.forEach(button => {
    const description = button.querySelector('.description');

    if (description) {
        const tl = gsap.timeline({ paused: true });

        // Animate height, opacity and margin from 0 to their natural CSS values
        tl.from(description, { height: 0, opacity: 0, margin: 0, duration: 0.3, ease: "power2.out" });

        let isHovered = false;
        let isFocused = false;

        const updateState = () => {
            if (isHovered || isFocused) {
                tl.play();
            } else {
                tl.reverse();
            }
        };

        button.addEventListener('mouseenter', () => { isHovered = true; updateState(); });
        button.addEventListener('mouseleave', () => { isHovered = false; updateState(); });
        button.addEventListener('focus', () => { isFocused = true; updateState(); });
        button.addEventListener('blur', () => { isFocused = false; updateState(); });
    }
})



// Fade in and out animation mapped to scroll
// ---------------------------------------------------------------------------------------------------------------------
const animateScrollFadeInOut = document.querySelectorAll(".ani-scroll-fade-in-out");
animateScrollFadeInOut.forEach(item => {
    // Fade In Animation
    gsap.fromTo(item,
        { opacity: 0 },
        {
            opacity: 1,
            ease: "none",
            scrollTrigger: {
                trigger: item,
                start: "bottom 105%",
                end: "bottom 80%",
                scrub: true
            }
        }
    );

    // Fade Out Animation
    gsap.fromTo(item,
        { opacity: 1 },
        {
            opacity: 0,
            ease: "none",
            immediateRender: false, // Prevent conflict with the Fade In init
            scrollTrigger: {
                trigger: item,
                start: "top 22%",
                end: "top 7%",
                scrub: true
            }
        }
    );
});



// Scroll List
// ---------------------------------------------------------------------------------------------------------------------
let scrollLists = document.querySelectorAll('.scroll-list');
scrollLists.forEach((list) => {
    matchMedia.add("(min-width: 768px)", () => {
        // Scroll Content
        let scrollItems = list.querySelectorAll('.scroll-item');
        scrollItems.forEach((item, index) => {
            if (index === 0) {
                item.classList.add('active');
                ScrollTrigger.create({
                    trigger: item,
                    start: "top center",
                    end: "bottom center",
                    toggleClass: "active",
                    onLeaveBack: () => {
                        item.classList.add('active');
                    }
                });
            } else if (index === scrollItems.length - 1) {
                ScrollTrigger.create({
                    trigger: item,
                    start: "top center",
                    end: "bottom center",
                    toggleClass: "active",
                    onLeave: () => {
                        item.classList.add('active');
                    }
                });
            } else {
                ScrollTrigger.create({
                    trigger: item,
                    start: "top center",
                    end: "bottom center",
                    toggleClass: "active",
                });
            }

        })

        // Pin images
        let scrollImages = list.querySelectorAll('.scroll-item figure')
        scrollImages.forEach((image) => {
            ScrollTrigger.create({
                trigger: image,
                start: "center center",
                pin: true,
                endTrigger: '.scroll-list',
                end: () => '+=' + (list.offsetHeight - image.offsetHeight),
            })
        })
    })
});



// Generic Transition Classes
// ---------------------------------------------------------------------------------------------------------------------
const genericAnimationDuration = 1;
const genericAnimationEase = "power2";
const genericAnimationScroll = "top 80%";



// Scroll Sequence Block
// ---------------------------------------------------------------------------------------------------------------------
/**
 * GSAP Image Sequence
 * Helper function that handles scrubbing through a sequence of images, drawing the appropriate one to the provided canvas.
 *
 * Source:
 * @url https://gsap.com/docs/v3/HelperFunctions/helpers/imageSequenceScrub/
 *
 * @param {array} urls an Array of image URLs
 * @param {object} canvas the <canvas> object to draw to
 * @param {boolean|object} scrollTrigger an optional ScrollTrigger configuration object like {trigger: "#trigger", start: "top top", end: "+=1000", scrub: true, pin: true}
 * @param {boolean} clear if true, it'll clear out the canvas before drawing each frame (useful if your images contain transparency)
 * @param {boolean} paused true if you'd like the returned animation to be paused initially (this isn't necessary if you're passing in a ScrollTrigger that's scrubbed, but it is helpful if you just want a normal playback animation)
 * @param {int} fps optional frames per second - this determines the duration of the returned animation. This doesn't matter if you're using a scrubbed ScrollTrigger. Defaults to 30fps.
 * @param {boolean|function} onUpdate optional callback for when the Tween updates (probably not used very often). It'll pass two parameters: 1) the index of the image (zero-based), and 2) the Image that was drawn to the canvas
 *
 * @return {gsap.core.Tween} a Tween instance
 *
 */
function imageSequence(urls, canvas, scrollTrigger = false, clear = true, paused = false, fps = 30, onUpdate = false) {
    canvas = gsap.utils.toArray(canvas)[0] || console.warn("canvas not defined");
    let playhead = {frame: 0};
    let context = canvas.getContext("2d");
    let currentFrame = -1;
    let images;
    const updateImage = function () {
        let frame = Math.round(playhead.frame);
        if (frame !== currentFrame) { // only draw if necessary
            clear && context.clearRect(0, 0, canvas.width, canvas.height);
            context.drawImage(images[Math.round(playhead.frame)], 0, 0);
            currentFrame = frame;
            onUpdate && onUpdate.call(this, frame, images[frame]);
        }
    };
    images = urls.map((url, i) => {
        let img = new Image();
        img.src = url;
        i || (img.onload = updateImage);
        return img;
    });
    return gsap.to(playhead, {
        frame: images.length - 1,
        ease: "none",
        onUpdate: updateImage,
        duration: images.length / (fps),
        paused: !!paused,
        scrollTrigger: scrollTrigger
    });
}


const scrollSequenceBlock = document.querySelector(".scroll-sequence");
if (scrollSequenceBlock) {
    const canvas = scrollSequenceBlock.querySelector("#sequence-animation");
    const pointers = document.querySelectorAll('.pointer');
    const sequenceType = scrollSequenceBlock.dataset.sequence;
    const frameCount = Number(scrollSequenceBlock.dataset.frames ?? 0);
    let pointersActive = false;


    // Set pinned elements - includes elements before and after scroll sequence for similated scroll freeze behavior
    const parent = scrollSequenceBlock.parentElement;
    const previous = scrollSequenceBlock.previousElementSibling;
    const next = scrollSequenceBlock.nextElementSibling;
    const pinElements = [];
    if (previous && previous.parentElement === parent) {
        pinElements.push(previous);
    }
    pinElements.push(scrollSequenceBlock);
    if (next && next.parentElement === parent) {
        pinElements.push(next);
    }

    // Add wrapper around all scroll pinned elements
    if (pinElements.length > 1) {
        const pinWrapper = document.createElement("div");
        pinWrapper.className = "scroll-sequence-pin-wrapper";

        parent.insertBefore(pinWrapper, pinElements[0]);

        pinElements.forEach((element) => {
            pinWrapper.appendChild(element);
        });
    }

    // Load Core Images
    let urls = new Array(frameCount).fill().map((o, i) => `/wp-content/themes/epicstrap/assets/sequence-animations/${sequenceType}/${(i).toString()}.webp`);

    // Run the Image Sequence function
    imageSequence(
        urls,
        canvas,
        {
            trigger: canvas,
            start: "center center",
            end: "+=800",
            pin: scrollSequenceBlock.parentElement.classList.contains("scroll-sequence-pin-wrapper")
                ? scrollSequenceBlock.parentElement
                : scrollSequenceBlock,
            anticipatePin: 1,
            scrub: true,
            onUpdate: ({progress, direction, isActive}) => pointerAnimation(progress, direction, isActive),
        },
    );

    function pointerAnimation(progress, direction, isActive){
        const percentTrigger = 0.5;
        if (pointers) {
            if (progress >= percentTrigger && !pointersActive) {

                pointers.forEach((pointer, i) => {
                    const border = pointer.querySelector('.border');
                    const text = pointer.querySelector('.pointer-text');
                    const icon = pointer.querySelector('.pointer-icon');

                    if (border) {
                        gsap.to(border, {
                            width: '100%',
                            opacity: 1,
                            delay: i * 0.15,
                            duration: 1.2,
                            ease: genericAnimationEase
                        });
                    }
                    if (icon) {
                        gsap.to(icon, {
                            opacity: 1,
                            delay: i * 0.15,
                            duration: 1,
                            ease: genericAnimationEase
                        });
                    }
                    if (text) {
                        gsap.to(text, {
                            opacity: 1,
                            delay: i * 0.175,
                            duration: 1,
                            ease: genericAnimationEase
                        });
                    }

                })

                pointersActive = true;
            }

            if (progress < percentTrigger && pointersActive) {

                pointers.forEach((pointer, i) => {
                    const border = pointer.querySelector('.border');
                    const text = pointer.querySelector('.pointer-text');
                    const icon = pointer.querySelector('.pointer-icon');

                    if (border) {
                        gsap.to(border, {
                        width: 0,
                        opacity: 0,
                        duration: .5,
                        ease: genericAnimationEase
                    });
                    }
                    if (icon) {
                        gsap.to(icon, {
                        opacity: 0,
                        duration: .5,
                        ease: genericAnimationEase
                    });
                    }
                    if (text) {
                        gsap.to(text, {
                            opacity: 0,
                            duration: .5,
                            ease: genericAnimationEase
                        });
                    }
                })

                pointersActive = false;
            }
        }
    }

}




// =====================================================================================================================
// WPSL
// =====================================================================================================================
const wpslRadiusDropdown = document.querySelector('#wpsl-radius-dropdown-control');
if (wpslRadiusDropdown) {
    wpslRadiusDropdown.addEventListener('change', () => {
        const radius = wpslRadiusDropdown.value;
        const radiusInput = document.querySelector('#wpsl-radius .wpsl-selected-item');
        radiusInput.dataset.value = radius;
    })
}

const wpslResultsDropdown = document.querySelector('#wpsl-results-dropdown-control');
if (wpslResultsDropdown) {
    wpslResultsDropdown.addEventListener('change', () => {
        const results = wpslResultsDropdown.value;
        const resultsInput = document.querySelector('#wpsl-results .wpsl-selected-item');
        resultsInput.dataset.value = results;
    })
}




// =====================================================================================================================
// Mobile Megamenu
// =====================================================================================================================
const megamenuMobile = document.getElementById('mobile-megamenu');
if (megamenuMobile) {
    const track = megamenuMobile.querySelector('.mm-track');
    const backBtn = megamenuMobile.querySelector('.mm-back-btn');
    const rootPage = track.querySelector('[data-mm-page="root"]');
    const pages = Array.from(track.querySelectorAll('[data-mm-page]'));
    const pageById = new Map(pages.map((p) => [p.getAttribute('data-mm-page'), p]));
    const stack = ['root'];

    let isAnimating = false;

    function getCurrentPageId() {
        return stack[stack.length - 1];
    }

    function getPageEl(id) {
        return pageById.get(id) || null;
    }

    function setOnlyActive(id) {
        pages.forEach((page) => {
            page.classList.remove(
                'is-mm-active', 'is-mm-enter-right', 'is-mm-enter-left', 'is-mm-exit-left', 'is-mm-exit-right'
            );
        });

        const el = getPageEl(id);
        if (el) el.classList.add('is-mm-active');

        backBtn.hidden = rootPage.classList.contains('is-mm-active');
    }

    function animateTo(targetId, direction, onDone) {
        if (isAnimating) { return }
        const fromId = getCurrentPageId();
        if (targetId === fromId) { return }

        const fromEl = getPageEl(fromId);
        const toEl = getPageEl(targetId);
        if (!fromEl || !toEl) { return }

        isAnimating = true;

        // Reset state on both
        [fromEl, toEl].forEach((el) => {
            el.classList.remove(
                'is-mm-active', 'is-mm-enter-right', 'is-mm-enter-left', 'is-mm-exit-left', 'is-mm-exit-right'
            );
        });

        // Place the target offscreen, make both display:block
        if (direction === 'forward') {
            toEl.classList.add('is-mm-enter-right');
        } else {
            toEl.classList.add('is-mm-enter-left');
        }
        fromEl.classList.add('is-mm-active');

        backBtn.hidden = false;

        // Next frame: trigger transitions
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                if (direction === 'forward') {
                    fromEl.classList.add('is-mm-exit-left');
                    toEl.classList.remove('is-mm-enter-right');
                    toEl.classList.add('is-mm-active');
                } else {
                    fromEl.classList.add('is-mm-exit-right');
                    toEl.classList.remove('is-mm-enter-left');
                    toEl.classList.add('is-mm-active');
                }

                const finish = (e) => {
                    if (e.target !== toEl) return;
                    toEl.removeEventListener('transitionend', finish);

                    // Cleanup: only the target remains active (others become display:none via CSS)
                    setOnlyActive(targetId);

                    isAnimating = false;
                    onDone && onDone();
                };

                toEl.addEventListener('transitionend', finish);
            });
        });
    }

    function goTo(pageId) {
        if (!pageById.has(pageId)) return;

        // This will slide directly to the target, but ONLY current+target are ever rendered.
        animateTo(pageId, 'forward', () => {
            stack.push(pageId);
        });
    }

    function goBack() {
        if (stack.length <= 1) return;
        const targetId = stack[stack.length - 2];

        animateTo(targetId, 'back', () => {
            stack.pop();
        });
    }

    megamenuMobile.addEventListener('click', (e) => {
        const nextBtn = e.target.closest('.mm-page-link');
        if (nextBtn && megamenuMobile.contains(nextBtn)) {
            e.preventDefault();
            const target = nextBtn.getAttribute('data-mm-target');
            if (target) goTo(target);
            return;
        }

        const back = e.target.closest('.mm-back-btn');
        if (back && megamenuMobile.contains(back)) {
            e.preventDefault();
            goBack();
        }
    });

    megamenuMobile.addEventListener('hidden.bs.offcanvas', () => {
        isAnimating = false;
        stack.length = 1;
        stack[0] = 'root';
        setOnlyActive('root');
    });

    megamenuMobile.addEventListener('shown.bs.offcanvas', () => {
        setOnlyActive(getCurrentPageId());
    });

    setOnlyActive('root');
}




// =====================================================================================================================
// Desktop Megamenu
// =====================================================================================================================
const desktopNav = document.getElementById('desktop-nav');
if (desktopNav) {
    // Nav Links and Tabs
    const navLinks = desktopNav.querySelectorAll('.nav-link.has-megamenu'); // top level nav links
    const subnavDropdownLinks = desktopNav.querySelectorAll('.subnav-link.dropdown-toggle'); // sub level nav links
    const productTabs = document.querySelectorAll('.products-nav-tabs .tab-link'); // product tabs


    let isNavHovered = false;
    let isKeyboardNavActive = false;
    let navHoverTimeout;

    // Hide the dropdown menus on nav hover timeout
    function handleNavHoverChange() {
        clearTimeout(navHoverTimeout);

        if (breakpointManager.matchesBreakpointsUp('lg')) {
            navHoverTimeout = setTimeout(() => {
                if (!isNavHovered && !isKeyboardNavActive) {
                    navLinks.forEach((link) => {
                        const dropdownMenu = Dropdown.getOrCreateInstance(link);
                        dropdownMenu.hide();
                        link.blur();
                        link.classList.remove('active');
                    });
                }
            }, 1500);
        }
    }

    // Mouse hover events for overall nav
    nav.addEventListener('mouseenter', () => {
        isNavHovered = true;
        isKeyboardNavActive = false;
        handleNavHoverChange();
    });
    nav.addEventListener('mouseleave', () => {
        isNavHovered = false;
        handleNavHoverChange();
    });

    // Add hover exception for keyboard navigation
    nav.addEventListener('keydown', (e) => {
        const keyboardKeys = ['Tab', 'ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight', 'Enter', ' '];

        if (keyboardKeys.includes(e.key)) {
            isKeyboardNavActive = true;
            clearTimeout(navHoverTimeout);
        }
    });
    nav.addEventListener('focusout', () => {
        // Delay a bit so focus can move to submenu items without closing immediately
        setTimeout(() => {
            if (!nav.contains(document.activeElement)) {
                isKeyboardNavActive = false;
                handleNavHoverChange();
            }
        }, 0);
    });


    // Top level nav links
    navLinks.forEach((link) => {

        // Go to button page on click
        link.addEventListener('click', (e) => {
            const href = link.getAttribute('data-href');
            if (!href) { return; }

            // Mouse/pointer click only. Keyboard-triggered clicks usually have detail === 0.
            if (e.detail > 0) {
                e.preventDefault();
                e.stopImmediatePropagation();
                window.location.href = href;
            }
        }, true);


        // Open Megamenu on Hover
        link.addEventListener('mouseenter', () => {

            // Don't do anything if link is active
            if (link.classList.contains('show')) { return; }

            const dropdownMenu = Dropdown.getOrCreateInstance(link);

            // Hide other dropdowns (except for the current link)
            navLinks.forEach((otherLink) => {
                if (otherLink === link) { return; }
                Dropdown.getOrCreateInstance(otherLink).hide();
            });

            // Show the current dropdown
            dropdownMenu.show();

            // Apply plain focus state for hover interactions
            link.focus({ preventScroll: true });
        });
    });


    // Sublevel Nav links
    subnavDropdownLinks.forEach((link) => {
        link.addEventListener('mouseenter', () => {

            // Don't do anything if link is active
            if (link.classList.contains('show')) { return; }

            const dropdownMenu = Dropdown.getOrCreateInstance(link);

            // Hide other dropdowns (except for the current link)
            subnavDropdownLinks.forEach((otherLink) => {
                if (otherLink === link) { return; }
                Dropdown.getOrCreateInstance(otherLink).hide();
            });

            // Show the current dropdown
            dropdownMenu.show();

            // Apply plain focus state for hover interactions
            link.focus({ preventScroll: true });
        })
    })


    // Product Hovers
    productTabs.forEach((tab) => {
        tab.addEventListener('mouseenter', () => {

            // Don't do anything if link is active
            if (tab.classList.contains('active')) { return; }

            // Activate hovered tab (auto-hides other tabs)
            const tabContent = Tab.getOrCreateInstance(tab);
            tabContent.show();
        });
    })

}




// =====================================================================================================================
// Set Cookies
// =====================================================================================================================

/**
 * Get Cookie by Name
 *
 * @param name
 * @returns {string}
 */
function getCookieByName(name) {
    const cookies = document.cookie.split(';');

    // find the cookie by name
    const cookie = cookies.find((cookie) => {
        return cookie.trim().startsWith(`${name}=`);
    });

    // Return the cookie value or empty string if not found
    if (cookie) {
        return cookie.trim().substring(`${name}=`.length);
    } else {
        return '';
    }

}

/**
 * Set Cookie
 *
 * @param {string} name
 * @param {string} value
 * @param {int} days
 */
function setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
}

/**
 * Get Current Solution
 * Find the solution related to the current page
 *
 * @returns {string}
 */
function getCurrentSolution(){
    // Solution slugs as used in URL Params
    const solutionParamSlugs = [
        'environmental',
        'horticulture',
        'sports',
        'agriculture',
    ]

    // Solution slugs as used in URL Pathname
    const solutionURLSlugs = [
        'environmental-solutions',
        'horticulture-solutions',
        'golf-sports-solutions',
        'agriculture-solutions',
    ]

    const url = new URL(window.location.href);
    const params = url.searchParams;
    const solutionParam = params.get('solution');

    // Check Params before URL
    if (solutionParam && solutionParamSlugs.includes(solutionParam)) {
        return solutionParam;
    }

    // Check URL
    const urlPathname = url.pathname;
    const urlPathnameParts = urlPathname.split('/').filter(Boolean);
    const matchedSlug = urlPathnameParts.find(part => solutionURLSlugs.includes(part));
    if (matchedSlug) {
        return matchedSlug;
    }

    return '';
}

// Get the current page's related solution and set the cookie
const currentSolution = getCurrentSolution();
if (currentSolution) {
    setCookie('lastVisitedSolution', currentSolution, 2);
}

// Get the last visited solution from the cookie
let lastVisitedSolution = getCookieByName('lastVisitedSolution');
console.log('Last Visited Solution Cookie: ', lastVisitedSolution);


/**
 * Set Current Product Cookie
 * Get the product name from a product page and set the corresponding cookie
 *
 * @returns {void} sets the cookie
 */
function setCurrentProductCookie() {
    const url = new URL(window.location.href);

    // Check URL for '/products/' followed by a product slug
    const urlPathnameParts = url.pathname.split('/').filter(Boolean);
    const productsIndex = urlPathnameParts.indexOf('products');
    if (productsIndex !== -1 && urlPathnameParts[productsIndex + 1]) {
        const productName = document.getElementsByTagName('h1')[0].innerText;

        // If the Product exists, set the cookie
        if (productName) {
            // Clean the product name by removing ® and ™ symbols and trimming whitespace
            const cleanedProductName = productName.replace(/[®™]/g, '').trim();

            // Set the Cookie
            setCookie('lastVisitedProduct', cleanedProductName, 2);
        }
    }

}
setCurrentProductCookie();


/**
 * Set Current Page Cookie
 * Store the current page's path so it can be recalled as the last visited page
 *
 * @returns {void} sets the cookie
 */
function setPageCookies() {
    const lastVisited = getCookieByName('lastVisitedPage');
    console.log('Last Visited Page: ', lastVisited);

    // Get Current Page URL
    const url = new URL(window.location.href).href;

    // Set the Cookie
    setCookie('lastVisitedPage', url === lastVisited ? lastVisited : url, 2);
}
setPageCookies();



// =====================================================================================================================
// Tabs Block
// =====================================================================================================================

// Set to a specific tab based on URL parameter
const tabsBlocks = document.querySelectorAll('.tab-group-section');
tabsBlocks.forEach( (block) => {
    const urlParams = new URLSearchParams(window.location.search);
    const tabParam = urlParams.get('tab');

    if (tabParam) {
        // Set Tab as active
        const matchingLink = block.querySelector(`.nav-link[data-tab-param="${tabParam}"]`);
        if (matchingLink) {
            const bsTab = new Tab(matchingLink);
            bsTab.show();
        }

        // Set accordion pane as active
        const matchingPane = block.querySelector(`.collapse[data-tab-param="${tabParam}"]`);
        if (matchingPane) {
            const bsCollapse = new Collapse(matchingPane);
            bsCollapse.show();
        }
    }
})



// =====================================================================================================================
// Ketch Footer Modal
// =====================================================================================================================
document.addEventListener('DOMContentLoaded', function () {
    let ketchPrivacy = document.querySelectorAll('.ketch-privacy-settings a');
    ketchPrivacy.forEach(item => {
        item.addEventListener("click", e => {
            e.preventDefault();
            ketch('showExperience');
        });
    });
});



// =====================================================================================================================
// Video Modals
// =====================================================================================================================

/**
 * Post YouTube Command
 * Controls a YouTube oEmbed iframe directly via the postMessage command
 * protocol, bypassing the IFrame Player API (window.YT). Another script on
 * the page (e.g. GTM's YouTube trigger) can already hold the iframe's one
 * active YT.Player handshake, which silently prevents a second YT.Player
 * instance's onReady from ever firing. The widget itself doesn't care who
 * sends a command, so posting directly works regardless.
 *
 * @param iframe
 * @param func
 */
function postYouTubeCommand(iframe, func) {
    if (!iframe || !iframe.contentWindow) return;
    console.log('[Video Modal] postYouTubeCommand:', func, 'for', iframe.src);
    iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: func, args: [] }), '*');
}

/**
 * Load Vimeo API
 *
 * @returns {*}
 */
function loadVimeoApi() {
    if (!vimeoApiPromise) {
        vimeoApiPromise = new Promise(function (resolve) {
            if (window.Vimeo && window.Vimeo.Player) {
                resolve(window.Vimeo);
                return;
            }
            const tag = document.createElement('script');
            tag.src = 'https://player.vimeo.com/api/player.js';
            tag.onload = function () { resolve(window.Vimeo); };
            document.head.appendChild(tag);
        });
    }
    return vimeoApiPromise;
}

/**
 * Get Vimeo Modal Player
 * Wraps the oEmbed iframe already in the modal with the Vimeo Player API.
 * Reused on every open/close so the player is only created once per modal.
 *
 * @param modal
 */
function getVimeoModalPlayer(modal) {

    // Check if player already exists
    if (vimeoModalPlayers.has(modal)) {
        return vimeoModalPlayers.get(modal);
    }

    const wrapper = modal.querySelector('.video-oembed-wrapper[data-video-type="vimeo"]');
    const iframe = wrapper ? wrapper.querySelector('iframe') : null;
    if (!wrapper || !iframe) return null;

    const playerPromise = loadVimeoApi().then(function (Vimeo) {
        const player = new Vimeo.Player(iframe);
        return player.ready().then(function () { return player; });
    });

    vimeoModalPlayers.set(modal, playerPromise);
    return playerPromise;
}


// Autoplay / Pause Embedded Videos in Video Modal
const vimeoModalPlayers = new Map();
let vimeoApiPromise = null;

const videoModals = document.querySelectorAll('.video-modal-window');
videoModals.forEach(function (modal) {
    modal.addEventListener('shown.bs.modal', function () {
        console.log('[Video Modal] shown.bs.modal:', modal.id);

        const youtubeIframe = modal.querySelector('.video-oembed-wrapper[data-video-type="youtube"] iframe');
        if (youtubeIframe) postYouTubeCommand(youtubeIframe, 'playVideo');

        const vimeoPlayerPromise = getVimeoModalPlayer(modal);
        if (vimeoPlayerPromise) {
            vimeoPlayerPromise.then(function (player) {
                player.play().catch(function () {});
            });
        }

        const video = modal.querySelector('video');
        if (video) video.play().catch(function () {});
    });

    modal.addEventListener('hide.bs.modal', function () {
        console.log('[Video Modal] hide.bs.modal:', modal.id);

        const youtubeIframe = modal.querySelector('.video-oembed-wrapper[data-video-type="youtube"] iframe');
        if (youtubeIframe) postYouTubeCommand(youtubeIframe, 'pauseVideo');

        if (vimeoModalPlayers.has(modal)) {
            vimeoModalPlayers.get(modal).then(function (player) {
                player.pause().catch(function () {});
            });
        }

        const video = modal.querySelector('video');
        if (video) video.pause();
    });
});
